export default "__VITE_ASSET__07c684da__"